import { useGetCompetitionCollectionsMetadata } from '@pkg/hooks';

export function useLeaderboardThumbnails(collectionSlugs?: string[]) {
    const slugQuery = collectionSlugs?.join(',');
    const { data: metadata } = useGetCompetitionCollectionsMetadata({
        searchQuery: slugQuery || '',
        ignoreSignal: true,
        setMetadataStore: false,
    });

    return metadata?.map((md) => md.key_image || md.banner_image_url);
}
